import { SelectMenu } from 'src/components/SelectMenu';
import { CustomViewOperator } from 'src/graphql/entities/custom-view/custom-view-config/operators';
import { FilterSection } from './styles';

interface OperatorSelectorProps {
  operators?: readonly CustomViewOperator[];
  operator?: CustomViewOperator;
  onChange: (op: CustomViewOperator) => void;
}

export const OperatorSelector = ({ operators, operator, onChange }: OperatorSelectorProps) => (
  <SelectMenu
    label="Operator"
    options={(operators ?? []).map((o) => ({ value: o.value, title: o.display }))}
    value={operator?.value ?? null}
    menuWidth="max-content"
    menuSx={{ minWidth: '8rem' }}
    onChange={(value) => {
      const picked = operators?.find((o) => String(o.value) === value);
      if (picked) {
        onChange(picked);
      }
    }}
    renderTrigger={({ getTriggerProps }) => (
      <FilterSection {...getTriggerProps()} role="button" tabIndex={0}>
        {operator?.display}
      </FilterSection>
    )}
  />
);
